<template>
  <v-layout @mousemove="onMouseMove">
    <v-system-bar v-if="!isAsset" class="system-bar pa-9 elevation-1" app window>
      <menu-bar></menu-bar>
      <v-app-bar-nav-icon
          class="acd_menu"
          @click="$refs.navBar.drawer = !$refs.navBar.drawer"
      />
    </v-system-bar>
    <v-main class="default-main">
      <nav-bar v-if="!isAsset" ref="navBar"></nav-bar>
      <router-view></router-view>
    </v-main>
  </v-layout>
</template>

<script>
import MenuBar from "@/pages/Main/components/MenuBar.vue";
import NavBar from "@/pages/Main/components/NavBar.vue";
import {mapGetters} from "vuex";
import store from "@/store";

export default {
  name: "Default",
  components: {NavBar, MenuBar},
  data() {
    return {
      prevX: null, prevY: null,
      currentX: null, currentY: null,
      result: null, // "T" or "F"
      lastActiveTime: Date.now(),
      checkInterval: null,
      MAX_TIME: 30 * 60 * 1000, // 30분 = 1,800초
      INTERVAL: 1000 // 30초
    }
  },
  computed: {
    ...mapGetters("layout", {
      isAsset: "isAsset"
    }),
    ...mapGetters("login", {
      userData: "userData"
    })
  },
  mounted() {
    this.toggleTracking(this.$route.path);
  },
  watch: {
    $route(to) {
      this.toggleTracking(to.path); // 라우터 path에 따른 트레킹 시작 혹은 중지
    }
  },
  methods: {
    onMouseMove(e) {
      this.currentX = e.clientX;
      this.currentY = e.clientY;
    },
    toggleTracking(path) {
      if (this.checkInterval) {
        clearInterval(this.checkInterval);
        this.checkInterval = null;
      }

      if (path !== "/login") {
        this.startTracking();
      }
    },
    startTracking() {
      this.lastActiveTime = Date.now();
      this.checkInterval = setInterval(() => {
        const THRESHOLD = 10; // 10px(오차범위)

        if (
            this.prevX !== null &&
            this.prevY !== null &&
            Math.abs(this.prevX - this.currentX) <= THRESHOLD &&
            Math.abs(this.prevY - this.currentY) <= THRESHOLD
        ) {
          // 변경 없을 시
          this.result = "T";
        } else {
          // 변경 있을 시
          this.result = "F";
          this.prevX = this.currentX;
          this.prevY = this.currentY;
          this.lastActiveTime = Date.now();
        }

        // 최대시간 도달 시
        const elapsedTime = Date.now() - this.lastActiveTime;
        if (elapsedTime >= this.MAX_TIME) {
          this.handleTimeOut();
        }
      }, this.INTERVAL);
    },
    handleTimeOut() {
      clearInterval(this.checkInterval);
      this.checkInterval = null;
      this.showAlert({message: "로그인 세션이 만료되었습니다."});
      store.dispatch("login/logout", this.userData.id);
    }
  }
}
</script>

<style lang="scss" scoped>
.default-main {
  //background-color: #f8f8f8;
}
@media screen and (min-width: 1025px) {
  .acd_menu {
    display: none;
  }
}
</style>